const DATA_ATTR = 'data-troikas-rules';
const CLASS_PREFIX = 'troikas-rules';

export function initPersonalAccountGroups() {
    init();

    async function init() {

    }
}
